import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  recipeUsages: null,
  editedRecipeUsage: null,
  savedRecipeUsage: null,
  saveRecipeUsageSuccess: false,
  recipeUsageMode: "",
};

const recipeUsageSlice = createSlice({
  name: "recipeUsage",
  initialState,
  reducers: {
    setRecipeUsages: (state, action) => {
      state.recipeUsages = action.payload;
    },
    setEditedRecipeUsage: (state, action) => {
      state.editedRecipeUsage = action.payload;
    },
    setSavedRecipeUsage: (state, action) => {
      state.savedRecipeUsage = action.payload;
    },
    setSaveRecipeUsageSuccess: (state, action) => {
      state.saveRecipeUsageSuccess = action.payload;
    },
    setRecipeUsageMode: (state, action) => {
      state.recipeUsageMode = action.payload;
    },
  },
});

export const {
  setRecipeUsages,
  setEditedRecipeUsage,
  setSavedRecipeUsage,
  setSaveRecipeUsageSuccess,
  setRecipeUsageMode,
} = recipeUsageSlice.actions;
export default recipeUsageSlice.reducer;
